import React from 'react'
import { Outlet } from 'react-router-dom'
import Header from '../../components/Header'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Sidebar from '../../components/Sidebar'
import Grid from '@mui/material/Grid'
import useMe from '../../hooks/users/useMe'
import doctor from '../../assets/images/doctor.jpg'

const MainLayout = () => {
  const { data: me, isSuccess, isLoading } = useMe()

  if (isLoading) {
    return <div />
  }

  if (isSuccess) {
    return (
      <div>
        <header>
          <Header user={me} gotUser={isSuccess} />
        </header>
        <main>
          <Container
            maxWidth='xl'
            sx={{ mt: 2 }}
          >
            <Grid container spacing={2}>
              <Box
                component={Grid}
                item
                md={3}
                sx={{ display: { md: 'flex', xs: 'none' }}}
              >
                <Sidebar />
              </Box>
              <Grid 
                item 
                md={9} 
                xs={12}
              >
                <Outlet />
              </Grid>
            </Grid>
          </Container>
        </main>
      </div>
    )
  }

  return (
    <div>
      <header>
        <Header user={me} gotUser={isSuccess} />
      </header>
      <main>
        <Container
          maxWidth='xl'
          sx={{ mt: 2 }}
        >
          <Grid container spacing={2}>
            <Box
              component={Grid}
              item
              md={5}
              sx={{ 
                display: { md: 'flex', xs: 'none' }
              }}
            >
              <Box 
                component='img'
                src={doctor}
                alt='doctor holding covid test'
                sx={{
                  width: '100%',
                  height: '36rem'
                }}
              />
            </Box>
            <Grid 
              item 
              md={7} 
              xs={12}
            >
              <Outlet />
            </Grid>
          </Grid>
        </Container>
      </main>
    </div>
  )
}

export default MainLayout